import { z } from "zod";
import type { infer as zInfer } from "zod/lib/types";

export const tournament = z.object({
  category: z.string(),
  iconUri: z.string().nullable(),
  name: z.string(),
  next: z.boolean(),
  outrights: z.boolean(),
  priority: z.number(),
  sport: z.string(),
});

export type Tournament = zInfer<typeof tournament>;
